export type WorkerOutput<T> = { data: T; error?: string };
type Handler<O> = (event: MessageEvent<WorkerOutput<O>>) => void;

export class WorkerWrapper<I, O> {
  worker: Worker;
  constructor(creator: () => Worker) {
    this.worker = creator();
  }
  _addMessageListener = (handler: Handler<O>) =>
    this.worker.addEventListener('message', handler);
  _removeMessageListener = (handler: Handler<O>) =>
    this.worker.removeEventListener('message', handler);
  _postMessage = (message: I) => this.worker.postMessage(message);

  call(message: I) {
    return new Promise<O>((resolve, reject) => {
      this.worker.addEventListener('error', (event) => {
        reject(event.error);
      });

      const handler: Handler<O> = ({ data: { data, error } }) => {
        if (error) reject(new Error(error));
        resolve(data);
        this._removeMessageListener(handler);
      };

      this._addMessageListener(handler);

      this._postMessage(message);
    });
  }

  terminate() {
    this.worker.terminate();
  }
}

// const CoreWorker = WorkerWrapper.bind(
//   WorkerWrapper,
//   () => new Worker(new URL('./executor', import.meta.url))
// );
